export enum AuthStorageKey {
  CustomToken = "nd_im_customToken",
}
